// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"e8e7fa82","98":"29c9adc5","204":"5867a9cf","231":"7d6d7e5e","244":"123cf932","306":"983d18d7","309":"c2c8fd98","394":"2ad37ee0","508":"689d25a9","539":"74c70876","738":"99d5bb8e","814":"6a8fec24","925":"62712f58"}[chunkId] + ".chunk.js";
};